export const providers = {
  GOOGLE: "google",
  MICROSOFT: "microsoft",
  FACEBOOK: "facebook"
};

export const ERROR_MESSAGES = {
  user_cancelled: "Operación cancelada",
  access_denied: "Acceso denegado.",
  interaction_in_progress:
    "Una ventana de inicio de sesión ya está abierta. Por favor, complete la autenticación en la ventana existente.",
  login_required:
    "Se requiere inicio de sesión. Revise sus medios de autenticación.",
  block_nested_popups: "Cierre esta ventana emergente y vuelva a intentarlo."
};
